<ng-container *ngIf="data$ | async as data">
  <button class="btn btn-sm btn-primary" (click)="open()">
    {{ data.title }}
  </button>
</ng-container>
